import axios from "axios";

export interface StudentLogItem {
  id: string;
  studentId: string;
  academicSessionId?: string | null;
  action: string;
  module: string;
  description: string;
  performedBy?: string | null;
  ipAddress?: string | null;
  createdAt: string;
  student?: {
    firstName: string;
    lastName: string;
    admissionNumber: string;
    scholarNumber: string | null;
  };
}

export const studentLogApi = {
  list: async (params: {
    studentId?: string;
    sessionId?: string;
    module?: string;
    action?: string;
    dateFrom?: string;
    dateTo?: string;
    skip?: number;
    take?: number;
  }) => {
    const res = await axios.get<{ items: StudentLogItem[]; total: number }>("/scholar-register/student-log", {
      params,
    });
    return res.data;
  },
  historyByStudent: async (studentId: string) => {
    const res = await axios.get<StudentLogItem[]>(`/scholar-register/student-log/student/${studentId}`);
    return res.data;
  },
};
